import { ConnectorsCard } from "./ConnectorsCard";
import { PairingCodeCard } from "./PairingCodeCard";
import { TestTaskCard } from "./TestTaskCard";

export const ConnectClinicPanel = () => (
  <div className="flex h-full flex-col gap-4 pr-2 font-body">
    <ConnectorsCard />
    <PairingCodeCard />
    <TestTaskCard />
  </div>
);
